module.exports = __webpack_public_path__ + "img/symbol_12.b8e4d760.png";